package org.example.project.screens_cus_mobile.wa

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import org.example.project.dashboard.DashboardTheme
import org.example.project.screens_cus_mobile.loadMobileErlaubteStandorte
import org.example.project.screens_cus_mobile.mobileStandortErlaubt
import org.example.project.service.YardApi
import org.example.project.service.YardEngineApi
import org.example.project.service.ZustandManager
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.example.project.settings.LumaticaCheckbox
import org.example.project.utils.All
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun CUSMobileWAKontrolleScreen(
    auftrag: All,
    kontrolleDefinitionen: List<All>,
    abschlussAuftraege: List<All>,
    showLeergutKontrolle: Boolean,
    onZurueck: () -> Unit,
    onAbschliessen: suspend (String, Map<String, String>, String) -> Unit,
    onAbschliessenMehrfach: suspend (String, Map<String, String>, Map<String, String>) -> Unit
) {
    val scope = rememberCoroutineScope()
    val antworten = remember(auftrag.id) { mutableStateMapOf<String, String>() }
    val abschlussRows = remember(auftrag.id, abschlussAuftraege) { abschlussAuftraege.ifEmpty { listOf(auftrag) } }
    val istPalettenByAuftrag = remember(auftrag.id, abschlussAuftraege) { mutableStateMapOf<String, String>() }
    var istAbschlussSchritt by remember(auftrag.id) { mutableStateOf(kontrolleDefinitionen.isEmpty()) }
    var leergut by remember(auftrag.id) {
        mutableStateOf(auftrag.mobilLeergutKontrolle.ifBlank {
            auftrag.leerpalettenanzahl.takeIf { it > 0 }?.toString().orEmpty()
        })
    }
    var istPaletten by remember(auftrag.id) {
        mutableStateOf(auftrag.mobilIstPaletten.takeIf { it > 0 }?.toString().orEmpty().ifBlank {
            auftrag.palettenanzahl.takeIf { it > 0 }?.toString().orEmpty()
        })
    }
    var aktuellerAbschlussIndex by remember(auftrag.id) { mutableStateOf(0) }
    var busy by remember(auftrag.id) { mutableStateOf(false) }
    var validationError by remember(auftrag.id) { mutableStateOf("") }
    val sortierteKontrollen = remember(kontrolleDefinitionen) {
        kontrolleDefinitionen.sortedWith(cusMobileWAKontrollComparator())
    }
    val teilabschluss = abschlussRows.size > 1

    LaunchedEffect(auftrag.id, sortierteKontrollen.size, abschlussRows) {
        antworten.clear()
        istAbschlussSchritt = sortierteKontrollen.isEmpty()
        aktuellerAbschlussIndex = 0
        sortierteKontrollen.forEach { def ->
            val key = cusMobileWAKontrollKey(def)
            antworten[key] = auftrag.palettenWerte[key].orEmpty().ifBlank {
                if (def.kontrollTyp.equals("checkbox", true)) "\u2B1C" else ""
            }
        }
        istPalettenByAuftrag.clear()
        abschlussRows.forEach { row ->
            val key = cusMobileWAAbschlussKey(row)
            istPalettenByAuftrag[key] = row.mobilIstPaletten.takeIf { it > 0 }?.toString().orEmpty().ifBlank {
                row.palettenanzahl.takeIf { it > 0 }?.toString().orEmpty()
            }
        }
    }

    val aktuellerRow = abschlussRows.getOrNull(aktuellerAbschlussIndex.coerceIn(0, abschlussRows.lastIndex)) ?: auftrag
    val aktuellerKey = cusMobileWAAbschlussKey(aktuellerRow)

    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(12.px)
            width(100.percent)
            height(100.percent)
            minHeight(0.px)
            flex(1)
        }
    }) {
        if (!istAbschlussSchritt) {
            Div({
                style {
                    flex(1)
                    minHeight(0.px)
                    overflowY("auto")
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center)
                    gap(12.px)
                    paddingBottom(4.px)
                }
            }) {
                Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(16.px); fontWeight("900") } }) {
                    Text("Warenausgang kontrollieren")
                }
                sortierteKontrollen.forEach { def ->
                    val key = cusMobileWAKontrollKey(def)
                    val wert = antworten[key].orEmpty()
                    Div({
                        style {
                            padding(14.px)
                            width(100.percent)
                            borderRadius(8.px)
                            backgroundColor(DashboardTheme.SURFACE_CARD)
                            property("border", "1px solid rgba(255,255,255,0.08)")
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Column)
                            alignItems(AlignItems.FlexStart)
                            gap(10.px)
                            boxSizing("border-box")
                        }
                    }) {
                        Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(16.px); fontWeight("900"); lineHeight("1.3"); textAlign("left") } }) {
                            Text(cusMobileWAKontrollLabel(def))
                        }
                        CUSMobileWAKontrollField(def, wert) {
                            antworten[key] = it
                            validationError = ""
                        }
                    }
                }
                if (validationError.isNotBlank()) {
                    Span({ style { color(DashboardTheme.ACCENT); fontSize(13.px); fontWeight("700") } }) {
                        Text(validationError)
                    }
                }
            }

            CUSMobileWAKontrolleFooter("Zurück", "Weiter", busy, onZurueck) {
                val offen = sortierteKontrollen.firstOrNull { def ->
                    cusMobileWAKontrollAntwortFehlt(def, antworten[cusMobileWAKontrollKey(def)].orEmpty())
                }
                if (offen != null) {
                    validationError = "Bitte alle Prüfschritte bestätigen."
                } else {
                    istAbschlussSchritt = true
                    validationError = ""
                }
            }
        } else {
            Div({ style { flex(1); minHeight(0.px); width(100.percent); position(Position.Relative) } }) {
                Div({
                    style {
                        position(Position.Absolute)
                        top(0.px)
                        left(0.px)
                        width(100.percent)
                        textAlign("center")
                        color(DashboardTheme.TEXT_LIGHT)
                        fontSize(18.px)
                        fontWeight("900")
                    }
                }) {
                    Text(if (teilabschluss) "WA Teilabschluss ${aktuellerAbschlussIndex + 1}/${abschlussRows.size}" else "WA Abschluss")
                }
                Div({
                    style {
                        position(Position.Absolute)
                        top(50.percent)
                        left(50.percent)
                        property("transform", "translate(-50%, -50%)")
                        width(100.percent)
                        maxWidth(360.px)
                        maxHeight(100.percent)
                        overflowY("auto")
                        paddingBottom(6.px)
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        alignItems(AlignItems.Center)
                        gap(24.px)
                        textAlign("center")
                        boxSizing("border-box")
                    }
                }) {
                    if (teilabschluss) {
                        CUSMobileWATeilabschlussScreen(
                            row = aktuellerRow,
                            rowKey = aktuellerKey,
                            value = istPalettenByAuftrag[aktuellerKey].orEmpty(),
                            palettenIstLabel = "Wie viele Paletten wurden verladen?",
                            onValueChange = {
                                istPalettenByAuftrag[aktuellerKey] = it
                                validationError = ""
                            }
                        )
                    } else {
                        CUSMobileWAAbschlussScreen(
                            leergut = leergut,
                            showLeergutKontrolle = showLeergutKontrolle,
                            onLeergutChange = {
                                leergut = it
                                validationError = ""
                            },
                            istPaletten = istPaletten,
                            onIstPalettenChange = {
                                istPaletten = it
                                validationError = ""
                            }
                        )
                    }
                    if (validationError.isNotBlank()) {
                        Span({ style { color(DashboardTheme.ACCENT); fontSize(13.px); fontWeight("700") } }) {
                            Text(validationError)
                        }
                    }
                }
            }

            CUSMobileWAKontrolleFooter(
                leftLabel = "Zurück",
                rightLabel = when {
                    busy -> "Speichere..."
                    teilabschluss && aktuellerAbschlussIndex < abschlussRows.lastIndex -> "Weiter"
                    else -> "WA Abschließen"
                },
                busy = busy,
                onZurueck = {
                    if (busy) return@CUSMobileWAKontrolleFooter
                    if (teilabschluss && aktuellerAbschlussIndex > 0) {
                        aktuellerAbschlussIndex -= 1
                        validationError = ""
                    } else {
                        istAbschlussSchritt = false
                        validationError = ""
                    }
                },
                onWeiter = {
                    if (busy) return@CUSMobileWAKontrolleFooter
                    if (teilabschluss) {
                        val currentValue = istPalettenByAuftrag[aktuellerKey].orEmpty()
                        if (currentValue.toIntOrNull() == null) {
                            validationError = "Bitte Anzahl Paletten eingeben."
                            return@CUSMobileWAKontrolleFooter
                        }
                        if (aktuellerAbschlussIndex < abschlussRows.lastIndex) {
                            aktuellerAbschlussIndex += 1
                            validationError = ""
                            return@CUSMobileWAKontrolleFooter
                        }
                        if (abschlussRows.any { row -> istPalettenByAuftrag[cusMobileWAAbschlussKey(row)].orEmpty().toIntOrNull() == null }) {
                            validationError = "Bitte alle Lieferscheine abschließen."
                            return@CUSMobileWAKontrolleFooter
                        }
                    } else if (istPaletten.toIntOrNull() == null) {
                        validationError = "Bitte Ist-Menge eingeben."
                        return@CUSMobileWAKontrolleFooter
                    }
                    busy = true
                    scope.launch {
                        if (teilabschluss) {
                            onAbschliessenMehrfach(leergut, antworten.toMap(), istPalettenByAuftrag.toMap())
                        } else {
                            onAbschliessen(leergut, antworten.toMap(), istPaletten)
                        }
                        busy = false
                    }
                }
            )
        }
    }
}

@Composable
private fun CUSMobileWAKontrollField(definition: All, wert: String, onValueChange: (String) -> Unit) {
    definition.beschreibung?.takeIf { it.isNotBlank() }?.let { text ->
        P({ style { margin(0.px); color(DashboardTheme.TEXT_MUTED); fontSize(13.px); lineHeight("1.5") } }) {
            Text(text)
        }
    }
    val options = definition.kontrollOptions.filter { it.isNotBlank() }
    when {
        options.isNotEmpty() -> {
            Select({
                attr("value", wert)
                style {
                    height(56.px)
                    width(100.percent)
                    padding(0.px, 14.px)
                    color(DashboardTheme.TEXT_LIGHT)
                    backgroundColor(Color("rgba(255,255,255,0.04)"))
                    property("border", "1px solid rgba(255,255,255,0.14)")
                    borderRadius(8.px)
                    property("box-sizing", "border-box")
                    fontSize(17.px)
                    fontWeight("900")
                }
                onInput { onValueChange(it.value.orEmpty()) }
            }) {
                Option("") { Text("Auswahl") }
                options.forEach { option -> Option(option) { Text(option) } }
            }
        }
        definition.kontrollTyp.equals("checkbox", true) -> {
            Div({ style { width(100.percent); display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center) } }) {
                LumaticaCheckbox(
                    checked = cusMobileWAKontrollCheckboxChecked(wert),
                    onChange = { checked -> onValueChange(if (checked) "\u2705" else "\u2B1C") },
                    fontSizePx = 30
                )
            }
        }
        cusMobileWAIstTemperaturKontrolle(definition) -> {
            Div({
                style {
                    height(56.px)
                    width(100.percent)
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    backgroundColor(Color("rgba(255,255,255,0.04)"))
                    property("border", "1px solid rgba(255,255,255,0.14)")
                    borderRadius(8.px)
                    property("box-sizing", "border-box")
                }
            }) {
                Input(InputType.Text) {
                    value(wert)
                    attr("placeholder", "Temperatur")
                    style {
                        height(100.percent)
                        flex(1)
                        minWidth(0.px)
                        padding(0.px, 12.px)
                        color(DashboardTheme.TEXT_LIGHT)
                        backgroundColor(Color.transparent)
                        property("border", "0")
                        property("outline", "0")
                        property("box-sizing", "border-box")
                        fontSize(17.px)
                        fontWeight("900")
                        textAlign("center")
                    }
                    onInput { onValueChange(it.value) }
                }
                Span({ style { paddingRight(14.px); color(DashboardTheme.TEXT_LIGHT); fontSize(17.px); fontWeight("900") } }) {
                    Text("°C")
                }
            }
        }
        else -> {
            Input(InputType.Text) {
                value(wert)
                attr("placeholder", "Antwort eingeben")
                style {
                    height(56.px)
                    width(100.percent)
                    padding(0.px, 14.px)
                    color(DashboardTheme.TEXT_LIGHT)
                    backgroundColor(Color("rgba(255,255,255,0.04)"))
                    property("border", "1px solid rgba(255,255,255,0.14)")
                    borderRadius(8.px)
                    property("box-sizing", "border-box")
                    fontSize(17.px)
                    fontWeight("900")
                    textAlign("center")
                }
                onInput { onValueChange(it.value) }
            }
        }
    }
}

@Composable
private fun CUSMobileWAKontrolleFooter(
    leftLabel: String,
    rightLabel: String,
    busy: Boolean,
    onZurueck: () -> Unit,
    onWeiter: () -> Unit
) {
    Div({ style { width(100.percent); display(DisplayStyle.Flex); boxSizing("border-box") } }) {
        Div({ style { flex(1); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center) } }) {
            Div({ style { width(150.px); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center) } }) {
                LumaticaButton(leftLabel, onZurueck, variant = LumaticaButtonVariant.Standard, heightPx = 42, enabled = !busy)
            }
        }
        Div({ style { flex(1); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center) } }) {
            Div({ style { width(150.px); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center) } }) {
                LumaticaButton(rightLabel, onWeiter, variant = LumaticaButtonVariant.Action, heightPx = 42, enabled = !busy)
            }
        }
    }
}

private fun cusMobileWAKontrollComparator(): Comparator<All> =
    compareBy<All> { it.abfragePrio.takeIf { prio -> prio > 0 } ?: it.kontrollId.toIntOrNull() ?: it.id.toIntOrNull() ?: Int.MAX_VALUE }
        .thenBy { it.kontrollId.toIntOrNull() ?: Int.MAX_VALUE }
        .thenBy { it.kontrollId.ifBlank { it.id } }

private fun cusMobileWAKontrollCheckboxChecked(value: String): Boolean =
    value == "\u2705" || value.equals("true", ignoreCase = true) || value.equals("ja", ignoreCase = true)

private fun cusMobileWAKontrollAntwortFehlt(definition: All, value: String): Boolean =
    definition.kontrollPflicht && if (definition.kontrollTyp.equals("checkbox", true)) {
        !cusMobileWAKontrollCheckboxChecked(value)
    } else {
        value.isBlank()
    }

private fun cusMobileWAIstTemperaturKontrolle(definition: All): Boolean {
    val text = listOf(definition.bezeichnung, definition.kontrollBezeichnung).joinToString(" ").lowercase()
    return "temperatur" in text
}

private fun cusMobileWAKontrollKey(definition: All): String =
    "mobil.kontrolle.${definition.id.ifBlank { cusMobileWAKontrollLabel(definition) }}"

private fun cusMobileWAKontrollLabel(definition: All): String =
    definition.kontrollBezeichnung.ifBlank { definition.bezeichnung.ifBlank { definition.id.ifBlank { "Kontrolle" } } }

private fun cusMobileWAAbschlussKey(auftrag: All): String =
    listOf(
        auftrag.lieferscheinnummer.ifBlank { auftrag.id.ifBlank { auftrag.lfdNr.toString() } },
        auftrag.waStandortId
            .ifBlank { auftrag.slotStandortId }
            .ifBlank { auftrag.platzcode }
            .ifBlank { auftrag.standort }
    ).filter { it.isNotBlank() }.joinToString("@")
